const API_VERSIONS = {
  v1: process.env.REACT_APP_API_VERSION,
  v2: process.env.REACT_APP_API_VERSION_2,
};

export const MERCHANT_API_URL = {
  GET_PROMOTED_PRODUCTS: API_VERSIONS.v1 + "/product/list/promotedProduct",
  FETCH_CATEGORIES: API_VERSIONS.v1 + "/category/getCategoryEnum",
  GET_PRODUCT: API_VERSIONS.v1 + "/product/ProductById",
  ADD_TO_CART: API_VERSIONS.v1 + "/cart/addCart",
  PRODUCT_MERCHANT_DETAIL: API_VERSIONS.v1 + "/product/merchantLocation",
  PRODUCTS_BY_CATEGORY: API_VERSIONS.v1 + "/product/productByCategory",
  GET_CART_LIST: API_VERSIONS.v1 + "/cart/getDetailsCart",
  GENERATE_VOUCHER: API_VERSIONS.v1 + "/cart/generateVoucher",
  VIEW_VOUCHER: API_VERSIONS.v1 + "/cart/ViewVoucher",
  SEARCH_PRODUCTS: API_VERSIONS.v1 + "/product/filter/list",
  DOWNLOAD_INVOICE: API_VERSIONS.v1 + "/voucher/download/web/vatReport",
  DOWNLOAD_ORDER_REPORT: API_VERSIONS.v1 + "/transporter/downloadOrderRecord",
  ORDER_HISTORY: (status, userHashId) =>
    API_VERSIONS.v1 +
    `/transporter/orderHistory?status=${status}&userHashId=${userHashId}`,
  UPDATE_SERVICE_CHARGE: API_VERSIONS.v1 + "/cart/removeCharge",
  UPDATE_ORDER_STATUS: API_VERSIONS.v1 + "/cart/changeStatus",
};

export const AUTH_API_URL = {
  SEND_OTP_URL: API_VERSIONS.v1 + "/user/sendOTP",
  VERIFY_OTP_URL: API_VERSIONS.v1 + "/user/verifyOtpAndGetUser",
  UPDATE_DEFAULT_PASSWORD: API_VERSIONS.v1 + "/user/setDefaultPass",
  TOKEN_FOR_PARTNER: API_VERSIONS.v1 + "/getTokenForPartner",
};

export const PRODUCT_API_URL = {
  SEND_OTP_URL: API_VERSIONS.v1 + "/program/sendOTP",
  VERIFY_OTP_URL: API_VERSIONS.v1 + "/program/verifyOtpAndGetUser",
  FETCH_USERS_CLIENT_DETAILS:
    API_VERSIONS.v1 + "/client/fetchUsersClientDetails",
  GET_ALL_PROGRAM: API_VERSIONS.v1 + "/program/fetch/all",
  GET_MOXEY_PROGRAM_ID: API_VERSIONS.v1 + "/program/findByClientCode/",
  GET_TEAM_BALANCE: API_VERSIONS.v1 + "/program/teamBalancelist",
  GET_CLIENT: API_VERSIONS.v1 + "/client/fetchByCode",
  FETCH_CLIENT: API_VERSIONS.v1 + "/client/fetch",
  GET_USERS_LIST: API_VERSIONS.v1 + "/program/user/list",
  GET_SUBUSERS_LIST:
    API_VERSIONS.v1 + "/program/distributor/superDistributor/subUsers/list",
  GET_SUPERVISOR_LIST:
    API_VERSIONS.v1 +
    "/program/distributor/superDistributor/subUsers/productType/list",
  ADD_NEW_USER: API_VERSIONS.v1 + "/program/user/invitation",
  UPDATE_USER: API_VERSIONS.v1 + "/program/edit/userList",
  USAGE_REPORT: API_VERSIONS.v1 + "/program/user/usageReport/list",
  UPDATE_USER_STATUS: API_VERSIONS.v1 + "/program/user/active/inactive",
  CHANGE_PASSWORD: API_VERSIONS.v1 + "/program/changePassword",
  FORGOT_PASSWORD: API_VERSIONS.v1 + "/program/forgotPassword",
  RESET_PASSWORD: API_VERSIONS.v1 + "/program/resetPassword",
  CHECK_TOKEN_STATUS: API_VERSIONS.v1 + "/program/checkTokenStatus",

  // stats
  USER_COUNT: API_VERSIONS.v1 + "/program/userCount",

  // wps
  GET_WPS_TRANSPORTER_DETAILS: API_VERSIONS.v1 + "/wps",
  GET_WPS_RECENTLY_PAID_SALARY: API_VERSIONS.v1 + "/wps/transactions",
  WPS_UPLOAD_SIF_FILE: API_VERSIONS.v1 + "/wps/initiate",
  WPS_CANCEL_FILE_UPLOAD: ({ customerId, referenceId }) =>
    API_VERSIONS.v1 + `/wps/${customerId}/${referenceId}/cancel`,
  WPS_RETRY_FILE_UPLOAD: ({ customerId, referenceId }) =>
    API_VERSIONS.v1 + `/wps/${customerId}/${referenceId}/retry`,
  FETCH_WPS_STATISTICS: API_VERSIONS.v1 + "/wps/statistics",
  GET_EMPLOYEE_LIST: API_VERSIONS.v1 + "/wps/get-employeeDetails",
  UPDATE_EMPLOYEE_STATUS: API_VERSIONS.v1 + "/wps/update/employee/status",
  ADD_EMPLOYEE: API_VERSIONS.v1 + "/wps/add/employee",
  FETCH_EMPLOYEE_SALARY_HISTORY: ({ employeeId, year }) =>
    API_VERSIONS.v1 + `/wps/${employeeId}/salaryHistory?year=${year}`,
  UPDATE_EMPLOYEE_DETAILS: API_VERSIONS.v1 + "/wps/update/employee/details",
  FETCH_GENERATE_SALARY_DETAILS: API_VERSIONS.v1 + "/wps/generate/salary",
  UPDATE_SALARY_EDR_DETAILS: API_VERSIONS.v1 + "/wps/update/employee/edr",
  UPDATE_SALARY_EVP_DETAILS: API_VERSIONS.v1 + "/wps/update/employee/evp",
  SUBMIT_WPS_SALARY: API_VERSIONS.v1 + "/wps/salary/submit",
  GET_WPS_SUMMARY: API_VERSIONS.v1 + "/wps/summary",
  GENERATE_SALARY_FOR_FAILED_RECOREDS: ({ refNumber }) =>
    API_VERSIONS.v1 + `/wps/generate/failed/salary/${refNumber}`,
  CLEAR_GENERATED_SALARY_DETAILS: API_VERSIONS.v1 + "/wps/delete/salary",
  GET_BANK_LIST: API_VERSIONS.v1 + "/wps/bank/details",

  FEATURE_FLAG: API_VERSIONS.v1 + "/client/features",
};

export const WALLET_API_URL = {
  PREFUND_REQUEST_URL: API_VERSIONS.v1 + "/client/",
  TAGGED_TRANSPORTERS: API_VERSIONS.v1 + "/tagged/client/list",
  REQUEST_PAYMENT: API_VERSIONS.v1 + "/client/payment",
  FEES_LIMIT_LIST: API_VERSIONS.v1 + "/wallet/feesmanagement/fees",
  LOAD_LIMIT_LIST: API_VERSIONS.v1 + "/fetch/transaction/limits",
  GET_AVAILABLE_PREF_BALANCE: API_VERSIONS.v1 + "/getAvailableBalance",
  GET_CARDS_STATS: API_VERSIONS.v1 + "/get/card/page/stats",
  UPDATE_TEAM_BALANCE: API_VERSIONS.v1 + "/teamBalance",
  // dashboard
  GET_DRIVER_PAYMENT_REQ_STATS:
    API_VERSIONS.v1 + "/customer/paymentRequest/countEachLifecycleStatus",

  // reporting ledger
  GET_REPORT_LEDGER: API_VERSIONS.v1 + "/transactionLedger",
  GET_B2B_REPORT: API_VERSIONS.v1 + "/clientPaymentRequest/list",
  DOWNLOAD_B2B_REPORT:
    API_VERSIONS.v1 + "/download/clientPaymentRequest/report",

  // driver payment requests - Renamed as Claims and Advanced Requests
  GET_DPREQ_LIST: API_VERSIONS.v1 + "/customer/paymentRequest",
  GET_DPREQ_REPORT: API_VERSIONS.v1 + "/customer/paymentRequest/Report",
  DOWNLOAD_DPREQ_REPORT:
    API_VERSIONS.v1 + "/download/customer/payment/request/report",

  // reporting
  DOWNLOAD_PREFUND_REPORT: API_VERSIONS.v1 + "/download/client",
  DOWNLOAD_LEDGER_REPORT: API_VERSIONS.v1 + "/download/ledger/report",

  // request
  UPDATE_CARD_LOAD_STATUS: API_VERSIONS.v1 + "/approveOrRejectCardLoad",
  UPDATE_B2B_STATUS: API_VERSIONS.v1 + "/clientPaymentRequest/approve/reject",
  UPDATE_DRIVER_PAYMENT_STATUS:
    API_VERSIONS.v1 + "/approve/reject/customer/payment/request",
  DOWNLOAD_PREFUND_REQ_REPORT:
    API_VERSIONS.v1 + "/download/prefund/request/list",
  DOWNLOAD_B2B_REQS_REPORT:
    API_VERSIONS.v1 + "/download/clientPaymentRequest/list",
  DOWNLOAD_DRIVER_REQS_REPORT:
    API_VERSIONS.v1 + "/download/customer/payment/request/list",
  ALLOCATE_DRIVER_PAYMENT_REQ:
    API_VERSIONS.v1 + "/allocate/customer/payment/request",

  // Stats
  TOTAL_GROUP_PREFUND: API_VERSIONS.v1 + "/getTotalPrefundOfGroup",
  EDIT_DRIVER_PAY_REQS: API_VERSIONS.v1 + "/editPaymentRequest",
};

export const CARDS_API_URL = {
  CARD_LOAD: API_VERSIONS.v1 + "/cardLoadRequest",
  CARDS_LIST: API_VERSIONS.v1 + "/cards/list",
  CARDS_FILTER_LIST: API_VERSIONS.v1 + "/card/filter/list",
  TRANSFER_HISTORY: API_VERSIONS.v1 + "/loadCardRequestlist",
  CARDS_REQS_LIST: API_VERSIONS.v1 + "/loadCardRequestlist",

  // reportings page api urls
  CARD_LOAD_REPORT: API_VERSIONS.v1 + "/loadCardRequestlist",
  DOWNLOAD_CARD_LOAD_REPORT_CLIENT: API_VERSIONS.v1 + "/download/cardload/list",
  DOWNLOAD_CARD_LOAD_REPORT: API_VERSIONS.v1 + "/download/loadCard/requestList",

  // Stats
  COUNT_CARD_LOAD: API_VERSIONS.v1 + "/totalCardLoadRequests",
  CARD_LOAD_REQS_COUNT: API_VERSIONS.v1 + "/totalCardLoadRequests",

  // Bulk Operation
  BULK_OPERATION: API_VERSIONS.v1 + "/card/load/request/bulkFileUpload",
  BULK_DETAILED_SUMMARY: API_VERSIONS.v1 + "/bulkUploadSummaryReport",

  // IBAN
  GET_ACTIVE_IBAN: API_VERSIONS.v1 + "/getActiveIban",
};

export const CUSTOMER_API_URL = {
  // Download Image from Azure
  DOWNLOAD_IMAGE: API_VERSIONS.v1 + "/customer/download/image/azure/storage",
  DOWNLOAD_FILE: API_VERSIONS.v1 + "/customer/download/image/azure/storage",

  // Drivers Page
  CUSTOMERS_LIST: API_VERSIONS.v1 + "/customer/broker/filter/list",
  CUSTOMERS_STATS: API_VERSIONS.v1 + "/customer/driverCount",
  ONBOARD_DRIVER: API_VERSIONS.v1 + "/onboard/customer/broker/miniclient",
  BULK_OPERATION_DRIVER:
    API_VERSIONS.v1 + "/bulkCardholder/creation/fileUpload",

  BULK_ONBOARD_SUMMARY:
    API_VERSIONS.v1 + "/bulkCardholderSumaryReport/fetchAll",

  // expense management
  GET_EXPENSE_LIST: API_VERSIONS.v1 + "/expense/getExpenseCategories",
  ADD_NEW_CATEGORY: API_VERSIONS.v1 + "/expense/addExpenseCategory",
  UPDATE_CATEGORY_STATUS:
    API_VERSIONS.v1 + "/expense/client/updateExpenseCategoryStatus",
  GET_AVAILABLE_CATEGORY_LIST:
    API_VERSIONS.v1 + "/expense/getExpenseCategoriesName",
};
